<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@dh-io-owpi/shared/src/plugins/i18n';
import { FootnoteReference } from '@dh-io-owpi/shared/src/components/ssr/footnotes';

const i18n = useI18n();
const disclaimerText = computed(() => i18n.t('usp.disclaimer.text')?.trim());
const disclaimerFootnote = computed(() => i18n.t('usp.disclaimer.footnote')?.trim());
</script>

<template>
  <p v-if="disclaimerText" class="wb-text-s-static owpi-spa-usp__disclaimer">
    {{ disclaimerText }}
    <FootnoteReference v-if="disclaimerFootnote" :content="disclaimerFootnote" reference="owpi_spa-usp-footnote_1" />
  </p>
</template>

<style lang="scss">
@use '@/vars.scss';

.owpi-spa-usp__disclaimer {
  margin-inline: auto;
  width: var(--wb-grid-width);
  color: var(--wb-text-headline-text-subtitle-color);
  padding-block: #{vars.$disclaimer-spacing-top} #{vars.$disclaimer-spacing-bottom};
}
</style>
